import { render, staticRenderFns } from "./citationTraceEn.vue?vue&type=template&id=bcd62ab4&scoped=true"
import script from "./citationTraceEn.vue?vue&type=script&lang=js"
export * from "./citationTraceEn.vue?vue&type=script&lang=js"
import style0 from "./citationTraceEn.vue?vue&type=style&index=0&id=bcd62ab4&prod&lang=less&scoped=true"
import style1 from "./citationTraceEn.vue?vue&type=style&index=1&id=bcd62ab4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd62ab4",
  null
  
)

export default component.exports